import { render, staticRenderFns } from "./PRDepartment.vue?vue&type=template&id=192665db&scoped=true&"
import script from "./PRDepartment.vue?vue&type=script&lang=js&"
export * from "./PRDepartment.vue?vue&type=script&lang=js&"
import style0 from "./PRDepartment.vue?vue&type=style&index=0&id=192665db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192665db",
  null
  
)

export default component.exports